import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getMasterBookSet = async (id) => {
  let response;
  try {
    response = await apiWrapper("GET", `master_book_sets/${id}`, {}, false, null, "Migrated");
    console.log("getMasterBookSet response.data :>> ", response.data);

    store.commit("ticketing/setMasterBookSet", response.data);
    store.commit(
      "ticketing/setMasterBook",
      response.data.reference_master_book
    );
    return response.data;
  } catch (err) {
    console.log('ERROR"" getMasterBookSet():', err);
    throw err;
  }
};
